import type { PaymentAuditListResponseDto } from '@paladin-monorepo/common';
import API from '../api';

export const paymentAuditApi = {
  list(params?: { limit?: number; cursor?: string }): Promise<PaymentAuditListResponseDto> {
    return API.get<PaymentAuditListResponseDto>('/client/payment-audit-events', { params }).then((r) => r.data);
  },
};
